<template>
  <div>
    <Head title="Ausstattung" />
    <section>
      <h2>Ausstattung</h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 group">
        <div v-for="item in facilities" class="p-2 flex flex-row text-left group">
          <span class="pr-2 pt-1 inline-block">
            <svg class="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" /></svg>
          </span>
          <span class="inline-block">{{ item }}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

import 'vue-silentbox/dist/style.css'

export default {
  components: {
    Head,
  },
  layout: Layout,

  data() {
    return {
      facilities: ['kostenfreies WLAN', 'TV', 'Gemeinschaftsraum', 'Kochmöglichkeit', 'Radio', 'Wasserkocher', 'Elektroherd mit Backofen', 'Kühlschrank', 'Kaffeemaschine', 'Mikrowelle', 'Spülmaschine', 'Kochutensilien', 'Zustellbett möglich', '3x Doppelbett', '1x Einzelbett', '3 Bäder', '2 Duschen', '1 Badewanne', '3 WC', 'Garten', 'Reinigungsmittel', 'Waschmaschine', 'PKW-Parkplatz', 'Grillmöglichkeit', 'Terrasse', 'Haustier auf Anfrage', 'Bettwäsche und Handtücher auf Anfrage'],
      lightboxList: [],
      lightboxIndex: 0,
    }
  },
  methods: {
    openLightbox: function (list, index) {
      this.lightboxList = list
      this.lightboxIndex = index
    },
  },
}
</script>